import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    transformHttpResponse,
} from 'utils';
import { fetchAttendance } from './listAction';

export const ATTENDANCE_BULK_SUCCESS = 'ATTENDANCE_BULK_SUCCESS';

/**
 * "Mark All Present" / "Mark Selected Present" / "Mark Selected Absent" —
 * and any future bulk status — all call this SAME action with a different
 * `status`. `sportsmanIds: null` means every athlete registered for the
 * competition (Mark All Present); an array means only those selected.
 *
 * Refetches the list on success rather than patching N rows client-side —
 * simpler and less error-prone for a bulk change. Also dispatches
 * ATTENDANCE_BULK_SUCCESS (competitionId only) so CompetitionResult/listReducer
 * can mark that competition's draw rows stale — a bulk change may have
 * auto-advanced brackets server-side, and the results store has no other
 * way to learn about it (see saveAttendance for the single-edit case).
 */
export const bulkUpdateAttendance = (competitionId, status, sportsmanIds) => {
    return function(dispatch) {
        const options = apiRequestOptions(
            apiPath.ATTENDANCE.BULK,
            { status, sportsmanIds },
            { params: { competition: competitionId } }
        );

        return axios(options)
            .then(transformHttpResponse)
            .then(response => {
                dispatch({ type: ATTENDANCE_BULK_SUCCESS, competitionId });
                return dispatch(fetchAttendance(competitionId)).then(() => response.data);
            })
            .catch(rejectWithViolationMessage);
    }
};

const rejectWithViolationMessage = error => {
    const violations = error.response && error.response.data && error.response.data.violations;
    const message = (violations && violations.length && violations[0].message)
        || (error.response && error.response.data && error.response.data['hydra:description'])
        || (error.response && error.response.data && error.response.data.message)
        || 'Save failed';
    return Promise.reject(new Error(message));
};
